import AnxietyEmail from './AnxietyEmail';

export default AnxietyEmail;
